import React from 'react';
import { withStyles, createStyles } from '@material-ui/core';
import units from '../theme/units';
var OPENING_BRACKET = '\u201c';
var CLOSING_BRACKET = '\u201d';
var styles = function (theme) {
    var _a, _b, _c;
    return createStyles({
        blockquote: {
            position: 'relative',
            color: theme.palette.secondary.main,
            marginTop: units.rem(2.5),
            marginBottom: units.rem(2.5),
        },
        quoteStart: (_a = {
                fontSize: '10rem',
                position: 'absolute',
                lineHeight: units.rem(1),
                top: units.rem(3)
            },
            _a[theme.breakpoints.between('xs', 'sm')] = {
                fontSize: units.rem(6),
                top: units.rem(2),
                left: units.rem(1),
            },
            _a),
        quote: (_b = {
                padding: units.yx(0, 6),
                textAlign: 'center',
                '& > *': {
                    fontSize: units.rem(2),
                    color: theme.palette.secondary.main,
                }
            },
            _b[theme.breakpoints.between('xs', 'sm')] = {
                padding: units.rem(2),
            },
            _b),
        quoteEnd: (_c = {
                fontSize: units.rem(10),
                position: 'absolute',
                lineHeight: units.rem(1),
                bottom: 0,
                right: 0
            },
            _c[theme.breakpoints.between('xs', 'sm')] = {
                fontSize: units.rem(6),
                right: units.rem(1),
                bottom: units.rem(2),
            },
            _c),
    });
};
var MarkdownBlockquote = function (_a) {
    var children = _a.children, classes = _a.classes;
    return (React.createElement("blockquote", { className: classes.blockquote },
        React.createElement("div", { className: classes.quoteStart }, OPENING_BRACKET),
        React.createElement("div", { className: classes.quote }, children),
        React.createElement("div", { className: classes.quoteEnd }, CLOSING_BRACKET)));
};
export default withStyles(styles)(MarkdownBlockquote);
//# sourceMappingURL=MarkdownBlockquote.js.map